module.exports = __webpack_public_path__ + "static/img/b.9389cab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/relation/b.png
// module id = +ltm
// module chunks = 0